import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { Box, CssBaseline, useTheme } from '@mui/material';
import MonthlySumLog from './MonthlySumLog/MonthlySumLog';
import MonthlySumCurve from './MonthlySumCurve/MonthlySumCurve';

function MonthlySumReportTab() {
    const [key, setKey] = useState('Energy Log'); // Set default key to "Energy Log"
    const { spacing } = useTheme()
    return (
        <>
            <CssBaseline />
            <Box sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <Tabs
                    style={{ justifyContent: "flex-start", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Energy Log" title="Energy Log">
                        <MonthlySumLog />
                    </Tab>

                    <Tab eventKey="Energy Curve" title="Energy Curve">
                        <MonthlySumCurve/>
                    </Tab>
                    
                </Tabs>
            </Box>
        </>
    )
}

export default MonthlySumReportTab;
